import type { SVGProps } from "react";
const SvgIconUserMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <rect width={400} height={50} x={624} y={171} rx={25} ry={25} />
    <rect width={400} height={50} x={624} y={296} rx={25} ry={25} />
    <rect width={400} height={50} x={624} y={421} rx={25} ry={25} />
    <circle cx={341} cy={341.5} r={170.5} />
    <path d="M192 565.28h298c105.97 0 192 86.03 192 192V803c0 27.6-22.4 50-50 50H50c-27.6 0-50-22.4-50-50v-45.72c0-105.97 86.03-192 192-192" />
  </svg>
);
export default SvgIconUserMenu;
